import css from 'styled-jsx/css';

export default css`
  .action-wrapper {
    display: flex;
    gap: 5px;
  }
  .action {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    border: 1px solid #a41c1c;
    border-radius: 5px;
    background-color: transparent;
    padding: 6px 12px;
    cursor: pointer;
    font-family: 'Roboto-Medium';
    font-size: 14px;
    transition: all 0.3s ease-in;
  }
  @media (max-width: 425px) {
    .action {
      font-size: 13.5px;
      font-weight: bold;
      align-items: center;
      padding: 5px 12px;
    }
  }
  @media (max-width: 375px) {
    .action {
      font-size: 11px;
      font-weight: bold;
      align-items: center;
      padding: 5px 12px;
    }
  }
  @media (max-width: 321px) {
    .action {
      font-size: 10px;
      align-items: center;
      padding: 3px 7px;
    }
  }
  .action:hover {
    background-color: #a41c1c;
  }
  .video-wrapper {
    display: flex;
    flex-direction: column;
    align-items: end;
  }
  .no-video-banner {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #000;
    font-family: 'Eurostile-Bold';
    font-size: 28px;
    padding: 0 20px;
    text-align: center;
  }
  .input-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    padding: 20px;
  }
  .input-title {
    font-family: 'Roboto-Normal';
    margin: 0;
  }
  .input-mail {
    font-family: 'Roboto-Normal';
    padding: 5px 10px;
    width: 300px;
    font-size: 20px;
    border-radius: 8px;
  }
  .input-mail:focus {
    outline: none;
  }
  .input-mail::placeholder {
    color: black;
  }
  .input-mail:focus::placeholder {
    color: transparent;
  }
  .input-submit {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40.4px;
    background-color: #950810;
    font-family: 'Roboto-Medium';
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    padding: 5px 10px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
  }
  .input-submit:hover {
    background-color: #800006;
  }
  .video-wrapper {
    width: 70vw;
    height: 60vh;
  }

  @media (max-width: 768px) {
    .video-wrapper {
      width: 90vw;
      height: 56.25vw;
    }
    .no-video-banner {
      width: 90vw;
      height: 56.25vw;
      padding: 0 20px;
      text-align: center;
      font-size: 26px;
    }
  }

  @media (max-width: 480px) {
    .video-wrapper {
      width: 90vw;
      height: 56.25vw;
    }
    .no-video-banner {
      width: 90vw;
      height: 56.25vw;
      padding: 0 20px;
      text-align: center;
      font-size: 20px;
    }
  }
`;
